import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { readAll, remove } from "../lib/bookmarks";
import { Heart, ExternalLink, Trash2 } from "lucide-react";
import { Button } from "../components/ui/button";

export default function Bookmarks() {
  const [items, setItems] = useState([]);
  const load = () => setItems(readAll());
  useEffect(() => {
    load();
    const h = () => load();
    window.addEventListener("ktb-bookmarks-changed", h);
    return () => window.removeEventListener("ktb-bookmarks-changed", h);
  }, []);

  return (
    <div className="fade-in">
      <header className="mb-10">
        <div className="text-xs uppercase tracking-[0.2em] text-primary/80 font-medium mb-3">Bookmarks</div>
        <h1 className="font-serif text-4xl sm:text-5xl text-stone-900">Your saved verses.</h1>
        <p className="mt-4 text-lg text-stone-700 max-w-2xl leading-relaxed">
          Saved on this device. Sign in (coming soon) to sync across all your devices.
        </p>
      </header>

      {items.length === 0 ? (
        <div className="rounded-md border border-dashed border-stone-300 bg-white p-12 text-center" data-testid="bookmarks-empty">
          <Heart className="h-10 w-10 text-stone-400 mx-auto mb-3" strokeWidth={1.5} />
          <h3 className="font-serif text-2xl text-stone-900">No bookmarks yet</h3>
          <p className="mt-2 text-stone-600 max-w-md mx-auto">Tap the heart next to any verse in the Bible reader to save it here.</p>
          <Link to="/bible" className="inline-block mt-4"><Button variant="outline">Open the Bible</Button></Link>
        </div>
      ) : (
        <div className="space-y-3" data-testid="bookmarks-list">
          {items.map((b) => (
            <div key={b.key} className="rounded-md border border-stone-200 bg-white p-5 flex items-start gap-4" data-testid={`bookmark-${b.key}`}>
              <div className="flex-1 min-w-0">
                <div className="text-xs uppercase tracking-widest text-primary/80 mb-1">
                  {b.book_name} {b.chapter}:{b.verse} · {b.translation.toUpperCase()}
                </div>
                <div className="scripture" style={{ fontSize: "1.1rem", lineHeight: 1.75 }}>{b.text}</div>
              </div>
              <div className="flex flex-col gap-1 shrink-0">
                <Link to={`/bible?ref=${encodeURIComponent(`${b.book_name} ${b.chapter}:${b.verse}`)}`}>
                  <Button variant="ghost" size="sm" title="Open in reader"><ExternalLink className="h-4 w-4" strokeWidth={1.5} /></Button>
                </Link>
                <Button variant="ghost" size="sm" title="Remove" onClick={() => remove(b.key)} data-testid={`remove-${b.key}`}>
                  <Trash2 className="h-4 w-4 text-destructive" strokeWidth={1.5} />
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
